import styles from "./FreeTrialBadge.module.scss";

export function FreeTrialBadge(props: { background: string, textColor: string }) {
    return <div className={styles.container} style={{ backgroundColor: props.background, color: props.textColor }}>
        <span className={styles.text}>7 Day Free Trial</span>
    </div>
}